import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from "@angular/router";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { CommonModule } from "@angular/common";
import { SidebarComponent } from "../../components/sidebar/sidebar.component";
import { LoaderComponent } from "../../components/loader/loader.component";
import { ProgressLoaderComponent } from "../../components/progress-loader/progress-loader.component";
import { SidebarNewComponent } from "../../components/sidebar-new/sidebar-new.component";
import { NoAccessComponent } from "../../components/no-access/no-access.component";
import { PermissionConditionSet, PermissionService } from "../../services/permission.service";

interface SidebarToggleEvent {
  expanded: boolean;
  pinned: boolean;
  searching: boolean;
}

@Component({
  selector: "app-private-layout",
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SidebarComponent,
    LoaderComponent,
    ProgressLoaderComponent,
    SidebarNewComponent,
    NoAccessComponent
  ],
  templateUrl: "./private-layout.component.html",
  styleUrls: ["./private-layout.component.scss"]
})
export class PrivateLayoutComponent implements OnInit, OnDestroy {
  private static readonly DEFAULT_SIDEBAR_WIDTH = 89;
  private static readonly EXPANDED_SIDEBAR_WIDTH = 292;

  sidebarWidth = PrivateLayoutComponent.DEFAULT_SIDEBAR_WIDTH;
  isPinned = false;
  showSideNav = true;
  showContentWithoutPadding = false;
  hasPermission = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private permissionService: PermissionService
  ) {
  }

  ngOnInit(): void {
    this.setupRouteListener();
    this.updateRouteBasedState();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSidebarToggle({ pinned, expanded, searching }: SidebarToggleEvent): void {
    this.isPinned = pinned;

    this.sidebarWidth = (pinned || expanded || searching)
      ? PrivateLayoutComponent.EXPANDED_SIDEBAR_WIDTH
      : PrivateLayoutComponent.DEFAULT_SIDEBAR_WIDTH;
  }

  private setupRouteListener(): void {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => this.updateRouteBasedState());
  }

  private updateRouteBasedState(): void {
    let currentRoute = this.router.routerState.root;

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const routeData = currentRoute.snapshot.data;

        const permissionConditionSet = routeData["requiresPermission"] as PermissionConditionSet;
        this.hasPermission = permissionConditionSet ? this.permissionService.evaluatePermissionsForLoggedInUser(permissionConditionSet) : true;
        if(!this.hasPermission) return

      this.showSideNav = routeData["showSideNav"] ?? true;
      // this.showSideNav = true
      this.showContentWithoutPadding = routeData["showContentWithoutPadding"] ?? false;
    }
  }

}
